import PropTypes from 'prop-types'
import { JobHeader } from './JobHeader'
import { JobDescription } from './JobDescription'
import {
  CareerNoVacanciesContainer,
  CareerNoVacanciesMessage,
  CareerPageJobCardContainer,
  CareerPageJobHeaderSection,
} from '../styled'
import Inbox from '../../assets/svgs/inbox'
import { useTranslation } from 'react-i18next'

function JobCard({ selectedPosition, getInitials }) {
  const { t } = useTranslation()

  return (
    <CareerPageJobCardContainer>
      {selectedPosition ? (
        <>
          <JobHeader
            companyName={selectedPosition?.company?.companyName}
            logoUrl={selectedPosition?.company?.logo}
            title={selectedPosition?.title}
            city={selectedPosition?.city}
            country={selectedPosition?.country}
            workplaceType={selectedPosition?.workplaceType}
            employmentType={selectedPosition?.employmentType}
            invitationLink={selectedPosition?.invitationLink}
            easyApplyLink={selectedPosition?.easyApplyLink}
            getInitials={getInitials}
          />
          <JobDescription description={selectedPosition?.description} />
        </>
      ) : (
        <CareerPageJobHeaderSection height={'600px'}>
          <CareerNoVacanciesContainer>
            <Inbox width="44px" height="30px" />
            <CareerNoVacanciesMessage fontSize={14}>
              {t('careers.noMatchingPositions')}
            </CareerNoVacanciesMessage>
          </CareerNoVacanciesContainer>
        </CareerPageJobHeaderSection>
      )}
    </CareerPageJobCardContainer>
  )
}

JobCard.propTypes = {
  selectedPosition: PropTypes.shape({
    company: PropTypes.shape({
      companyName: PropTypes.string,
      logo: PropTypes.string,
    }),
    title: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    workplaceType: PropTypes.string,
    employmentType: PropTypes.string,
    invitationLink: PropTypes.string,
    easyApplyLink: PropTypes.string,
    description: PropTypes.string,
  }),
  getInitials: PropTypes.func.isRequired,
}

export default JobCard
